export const TODO_ASSIGNMENT_METHOD = {
  SYSTEM: 'system',
  EMPLOYER: 'employer',
  PROVIDER: 'provider',
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/constants.js